module.exports = __webpack_public_path__ + "icon-instagram.png?b8e02583b448f68d4e482e2400cf585f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-instagram.png
// module id = 245
// module chunks = 0